 import { createRouter, createWebHistory } from "vue-router";
import { inject } from 'vue';
import { storeToRefs } from 'pinia'
import HomeIndex from "../components/sites/HomeIndex.vue";
import LoginIndex from "../components/sites/LoginIndex.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeIndex,
  },
  {
    path: "/login",
    name: "login",
    component: LoginIndex,
  },


  // {
  //   // GESCHÜTZTE ROUTE: Benutzerprofil
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Verwende inject, um den userStore zu erhalten
  const userStore = inject('userStore');
  
  if (!userStore) {
    console.error('userStore is not available');
    next();
    return;
  }

  const { userData } = storeToRefs(userStore);

  // Beispiel: Überprüfe, ob der Benutzer eingeloggt ist
  if (to.meta.requiresAuth && !userData.value) {
    console.log('Benutzer ist nicht eingeloggt');
    next({ path: "/login" }); // Leite zur Login-Seite um
  } else {
    next(); // Erlaube die Navigation
  }
});
export default router;
